import { render } from "./events.vue?vue&type=template&id=186323ee&scoped=true"
import script from "./events.vue?vue&type=script&lang=ts"
export * from "./events.vue?vue&type=script&lang=ts"

import "./events.vue?vue&type=style&index=0&id=186323ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-186323ee"

export default script